import { DialogManager as Dialog } from "./DialogManager";
import { DialogManagerProvider as Provider } from "./DialogManager.provider";
import { useManager } from "./DialogManager.hooks";

export const DialogManager = {
  Dialog,
  Provider,
  useManager,
};
